import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import SectionHeadline from 'shared/components/SectionHeadline';
import { Switch } from 'shared/components/form/Inputs';
import { colors, fonts } from 'shared/defaultTheme';
import { LabelInput } from 'shared/components/Labels';
import CustomInput from 'shared/components/CustomInput';

import { ReactComponent as TextFieldIcon } from 'assets/icon-text-field.svg';

const IconContainer = styled.div`
  height: 24px;
  width: 24px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: ${({ backgroundColor }) => backgroundColor};
  border-radius: 50%;
  padding-left: 4px;
  padding-right: 4px;
  svg {
    height: 100%;
    width: 100%;
  }
  margin-top: 4px;
`;

const CustomEmailNotifyMain = styled.div`
  .label-switch {
    span {
      font-family: ${fonts.default};
      font-size: 12px;
      font-weight: bold;
      letter-spacing: 0;
      line-height: 15px;
    }
  }
`;

const BorderBox = styled.div`
  box-sizing: border-box;
  height: auto;
  border: 1px solid ${colors.lightSilver};
  padding: 10px;
  padding-left: 30px;
  padding-right: 17px;
  .custom-input__main input {
    outline: none;
  }
  .label-input {
    font-family: ${fonts.default};
    font-size: 12px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 15px;
  }
`;

const CustomEmailNotification = ({ mainColor, admins, setAdmins }) => {
  const { t } = useTranslation();
  const onChangeSendNotify = (admin) => {
    const newAdmins = admins.map((ad) => {
      if (ad.id === admin.id) {
        return { ...ad, sendNotify: !ad.sendNotify };
      }
      return { ...ad };
    });
    setAdmins(newAdmins);
  };

  const onChangeNameSendNotify = (e, admin) => {
    const newAdmins = admins.map((item) => {
      if (admin.id === item.id) {
        return { ...item, [e.target.name]: e.target.value };
      }
      return { ...item };
    });
    setAdmins(newAdmins);
  };

  return (
    <>
      <SectionHeadline
        className="general-customizer__section-headline-2"
        sectionNumber={3}
        label={t('general_customizer_section_custom_email_notification')}
        color={mainColor}
      />
      <CustomEmailNotifyMain
        className="general-customizer__switch-footer-logo-wrapper"
        key="custom-email-notify-main"
      >
        <>
          {admins.length > 0 &&
            admins.map((admin) => (
              <React.Fragment key={admin.id}>
                <Switch
                  classNameMain="text-uppercase label-switch"
                  id={`switchSendNotification-${admin.id}`}
                  label={t('general_customizer_active_notification')}
                  color={admin.sendNotify ? mainColor : colors.pattens}
                  textColor={mainColor}
                  value={!admin.sendNotify}
                  onChange={() => onChangeSendNotify(admin)}
                />
                <BorderBox className="mt-3 mb-3" key={`border-box-${admin.id}`}>
                  <div className="mb-3">
                    <LabelInput
                      className="text-uppercase"
                      label={t('general_tags')}
                      color={mainColor}
                    />
                    <CustomInput
                      type="text"
                      name="nameComplete"
                      Icon={() => (
                        <IconContainer
                          backgroundColor="transparent"
                          key={`name-icon-container-${admin.id}`}
                        >
                          <TextFieldIcon fill={colors.suvaGrey} />
                        </IconContainer>
                      )}
                      value={admin.nameComplete}
                      onChange={(event) => {
                        onChangeNameSendNotify(event, admin);
                      }}
                    />
                  </div>
                  <div className="mb-3">
                    <LabelInput
                      className="text-uppercase"
                      label={t('general_customizer_email')}
                      color={mainColor}
                    />
                    <CustomInput
                      key={`email-${admin.mail}`}
                      type="text"
                      name="email"
                      isReadOnly
                      Icon={() => (
                        <IconContainer
                          backgroundColor="transparent"
                          key={`mail-icon-container-${admin.mail}`}
                        >
                          <TextFieldIcon fill={colors.suvaGrey} />
                        </IconContainer>
                      )}
                      value={admin.mail}
                      onChange={() => ''}
                    />
                  </div>
                </BorderBox>
              </React.Fragment>
            ))}
        </>
      </CustomEmailNotifyMain>
    </>
  );
};

CustomEmailNotification.defaultProps = {
  mainColor: '',
  admins: [],
};

CustomEmailNotification.propTypes = {
  mainColor: PropTypes.string,
  admins: PropTypes.arrayOf(
    PropTypes.shape({
      nameComplete: PropTypes.string,
      u: PropTypes.string,
      showNotification: PropTypes.bool,
    })
  ),
  setAdmins: PropTypes.func.isRequired,
};

export default CustomEmailNotification;
